export const SET_DEALS_PAGE = "setDealsPage";
